export default {
  setRightDrawerCollapsers(state, payload) {
    state.state.rightDrawerCollapsers = payload;
  },
};
